export default __webpack_public_path__ + "assets/front/scss/error.31f9418972a8b007a87a1173af30a1a6.css";